import { get } from 'lodash';
import React, { FC } from 'react';
import CreateTable from '../../../../../../components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { NonRequired } from '../../../../../../lib/validation/ValidationTypes';
import { isTrue } from '../../../../../../utils/helper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
const P = Schema.attributes;

const Beschaeftigungswirkung: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Aussagen zur erzielten Beschäftigungswikung' description={PLATZHALTER_TEXT} />
			<CreateTable
				formStruc={formStrucBeschaeftigungswirkung(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
				columnsLabel={columnsLabel()}
			/>
		</>
	);
};
export default Beschaeftigungswirkung;

const columnsLabel = () => {
	let labels = ['', 'Angabe', 'Anzahl'];
	return labels;
};

export const formStrucBeschaeftigungswirkung = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					type: 'label',
					path: P.Aussagen_Zur_Erzielten_B_0144756741_eitsplaetze_Gesichert_Angabe.path,
				},

				{ ...P.Aussagen_Zur_Erzielten_B_0144756741_eitsplaetze_Gesichert_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Aussagen_Zur_Erzielten_B_0144756741_eitsplaetze_Gesichert_Angabe.path)) ?
					[P.Aussagen_Zur_Erzielten_B_0144834668_eitsplaetze_Gesichert_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Aussagen_Zur_Erzielten_B_0066169989_laetze_Neu_Geschaffen_Angabe.path,
				},

				{ ...P.Aussagen_Zur_Erzielten_B_0066169989_laetze_Neu_Geschaffen_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Aussagen_Zur_Erzielten_B_0066169989_laetze_Neu_Geschaffen_Angabe.path)) ?
					[P.Aussagen_Zur_Erzielten_B_0066157804_laetze_Neu_Geschaffen_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Aussagen_Zur_Erzielten_B_0164562405_Unternehmen_Erfolgen_Angabe.path,
				},

				{ ...P.Aussagen_Zur_Erzielten_B_0164562405_Unternehmen_Erfolgen_Angabe, type: 'radio', validation: [{ validateFunction: NonRequired }] },
				...(isTrue(get(application, P.Aussagen_Zur_Erzielten_B_0164562405_Unternehmen_Erfolgen_Angabe.path)) ?
					[P.Aussagen_Zur_Erzielten_B_0164615564_Unternehmen_Erfolgen_Anzahl]
				:	[]),
			],
		},
	];
	return struc;
};
